<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M19 5L5 19M19 19L5 5" stroke="currentColor" stroke-width="2" />
  </svg>
</template>
